import { Component } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-onlyfans-gag-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./onlyfans-gag-dialog.component.html",
  styleUrl: "./onlyfans-gag-dialog.component.scss"
})
export class OnlyfansGagDialogComponent {
  constructor(readonly ref: MatDialogRef<OnlyfansGagDialogComponent, void>) {}

  close(): void {
    this.ref.close();
  }
}
